export default __webpack_public_path__ + "static/media/pairing4.55844ddf.jpg";